import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { create } from "lodash";
import * as lendAPI from "../../api/lend";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  bookReturnList: [],
  studentList: [],
  bookTitle: [],
  
};

const addLendBooks = createAsyncThunk(
  "library/lend/books",
  async (params, { rejectWithValue }) => {
    try {
      const payload = {
        idLibraryBook: params?.id,
        regNumber: params?.regNumber,
        lendDate: params?.lendDate,
        dueDate: params?.dueDate,
      };
      const res = await lendAPI.addLendBooks(payload);
      if (res.data.statusCodeValue >= 400) {
        console.error(res.data.body.error);
        toast.error(res.data.body.error);

        return rejectWithValue(res.data.body.error);
      } else {
        toast.success("Lend books infromation added successfully");
      }
      return res.data;
    } catch (error) {}
  }
);

const addBookReturns = createAsyncThunk(
  "library/return/books",
  async (params, { rejectWithValue }) => {
    try {
      const payload = {
        id: params?.id,
        regNumber: params?.regNumber,
        returnedDate: params?.returnedDate,
        // "title": params?.title
      };
      const res = await lendAPI.addBookReturns(payload);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
        toast.success("Return books Infromation added successfully");
      }
      return res.data;
    } catch (error) {}
  }
);

const getBooksList = createAsyncThunk(
  "get/return/books",
  async (params, { rejectWithValue }) => {
    //console.log(params,"lendlist");
    try {
      // const payload = {
      //     "regNumber":params?.regNumber;
      //    { "limit":params?.limit,
      //     "offset": params?.offset,}
      // }
      const res = await lendAPI.getBooksList(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {}
  }
);

const getBooksTitle = createAsyncThunk(
  "/search/books",
  async (params, { rejectWithValue }) => {
    try {
      const res = await lendAPI.getBooksTitle(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {}
  }
);

const getStudentId = createAsyncThunk(
  "/student/search",

  async (params, { rejectWithValue }) => {
    try {
      const res = await lendAPI.getStudentId(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {}
  }
);

const searchStudentId = createAsyncThunk(
  "student/search",
  async (params, { rejectWithValue }) => {
    try {
      const res = await lendAPI.searchStudentId(params);
      return res.data?.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

//   const searchBooksTitle = createAsyncThunk(
//     "student/search",
//     async (params, { rejectWithValue }) => {
//       try {
//         const res = await lendAPI.getBooksTitle(params);
//         return res.data?.body;
//       } catch (error) {
//         rejectWithValue(error);
//       }
//     }
//   );

const lendSlice = createSlice({
  name: "lendSlice",
  initialState,
  reducers: {
    resetBookReturnList: (state, action) => {
      state.bookReturnList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBooksList.fulfilled, (state, action) => {
        //console.log(state,"get book list");
        return { ...state, bookReturnList: action.payload };
      })
      .addCase(getStudentId.fulfilled, (state, action) => {
        //console.log((state," get student id"));
        return { ...state, studentList: action.payload };
      })
      .addCase(getBooksTitle.fulfilled, (state, action) => {
        //console.log((state," get book title"));
        return { ...state, bookTitle: action.payload };
      });
  },
});

export default lendSlice.reducer;

const { resetBookReturnList } = lendSlice.actions;

export {
  addLendBooks,
  addBookReturns,
  getBooksList,
  getBooksTitle,
  getStudentId,
  searchStudentId,
  resetBookReturnList,
};
